export default function openTab(url: string, target: string = '_blank'): void {
  // HACK: Chrome opens new tabs within the same process. This causes problems with audio
  // contexts for voice, which are limited to 6 per process. By using "noopener" we force Chrome
  // to open them in separate processes.
  // When target is "_self", using "noopener" would force Chrome to open a new tab.
  const isChrome = / Chrome\//.test(navigator.userAgent)
  if (isChrome && target !== '_self') {
    window.open(
      url,
      target,
      'status,resizable,scrollbars,menubar,toolbar,noopener'
    )
  } else {
    const tab = window.open(url, target)
    if (tab) {
      tab.opener = null
    }
  }
}
